import variables from '@app/theme/variables'

import { COUNT_STATUS } from '@app/constants/countStatus'

import type { ObjectValuesType } from '@app/types'

export const getColor = (status: ObjectValuesType<typeof COUNT_STATUS>): string => {
  if (status === COUNT_STATUS.APPROVED) {
    return variables.successGreen
  }

  if (status === COUNT_STATUS.ACCEPTABLE) {
    return variables.warningYellow
  }

  if (status === COUNT_STATUS.NEEDS_CORRECTION) {
    return variables.dangerRed
  }

  return variables.gray
}
